import { render } from "./PageNotFound.vue?vue&type=template&id=30ee3f0a"
const script = {}

import exportComponent from "/var/www/victoriya-date.elena-dating.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__